module.exports={
  message: {
    "View": '查看',
    "Read More":"更多",
    "Show Less":"隱藏",
    "Close":"關閉",
    "gotoPage1":"前往第 ",
    "gotoPage2":" 頁",
    "Dining":"餐飲",
    "Shop":"商店",
    "Amenities":"設施",
    "Transportation":"如何前往",
    "Parking":"停車場",
    "Venue":"場地",
    "From":"",
    "From1":"起",
  }
}